// extracted by mini-css-extract-plugin
export default {"last_summary_row":"ProductDetailsSummary_last_summary_row__NrqWp","extra_info":"ProductDetailsSummary_extra_info__lBv0q"};